import React, { useState } from "react"
import { Link } from "gatsby"
import Onboarding from "../../components/Onboarding"

import * as styles from "./onboard.module.less"

export default () => {
  const [type, setType] = useState(1)
  return (
    <div className={styles.onboard}>
      <div>
        <div className="container text-end">
          <Link to={"/locations?location=Toronto"}>
            <img src={require("./close.svg").default} alt="" />
          </Link>
        </div>
      </div>
      <div className="container">
        <div className={styles.onboard_wrapper}>
          <Switcher type={type} setType={setType} />
          <Onboarding onDemand={type === 2} locationsPage={true} />
        </div>
      </div>
    </div>
  )
}

const Switcher = ({ type, setType = () => null }) => {
  return (
    <ul className={styles.switcher}>
      <li className={type === 1 ? styles.active : ""}>
        <button className={`btn`} onClick={() => setType(1)}>
          Monthly Spaces
        </button>
      </li>
      <li className={type === 2 ? styles.active : ""}>
        {process.env.GATSBY_TEMPORARY_NOT_AVAILABLE ? (
          <Link
            className={`btn`}
            to={`/${process.env.GATSBY_TEMPORARY_NOT_AVAILABLE}`}
          >
            On-demand Offices
          </Link>
        ) : (
          <button className={`btn`} onClick={() => setType(2)}>
            On-demand offices
          </button>
        )}
      </li>
    </ul>
  )
}
